import { Grid, PageBody, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { SchedulePreshiftComponent, SchedulePreshiftInstructions } from '../onboarding/steps/schedulePreshift'
import { useOrg } from '../organization/useOrg'

export const SchedulePreshiftPage = () => {
  const org = useOrg()
  if (!org) return null
  return (
    <PageBody maxWidth="lg">
      <Typography variant="h1" gutterBottom>
        Shift scheduling
      </Typography>

      <Grid container spacing={2} flexDirection="row-reverse">
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h4" color="text.secondary" gutterBottom>
            Instructions
          </Typography>

          <SchedulePreshiftInstructions />
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <SchedulePreshiftComponent />
        </Grid>
      </Grid>
    </PageBody>
  )
}
